import React, { useState } from 'react'
const Textarea = ({ name, type, placeholder, onChange, width, error, height, marginLeft, color, money, value, rightEye, topEye, mask, disabled }) => {


    const [stateEye, setStateEye] = useState(false)

    const containerInput = {

        display: "flex",
        flexDirection: "column",
        marginLeft: marginLeft,
        width: width,
    }
    const styleInput = {
        width: width != undefined ? width : "418px",
        color: color != undefined ? color : "",
        height: height != undefined ? height : "50px",
        borderRadius: "10px",
        border: "1px solid #D7D7D7",
        marginBottom: "1.9rem",
        outline: "none",
        backgroundColor: disabled && "#f4f4f4",
        resize: "none",
        padding: "15px",
    }
    const styleLabel = {
        marginBottom: "14.43px"
    }
    const containerInputMail = {
        width: width != undefined ? width : "418px",

        display: "flex",
        flexDirection: "column",
        position: "relative",

    }
    const containerInputPassowrd = {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: width != undefined ? width : "418px",

    }
    const image = {

        position: "absolute",
        right: 0,
        top: topEye != undefined ? topEye : "50px",
        right: rightEye != undefined ? rightEye : "10px",
        cursor: "pointer"
    }

    return (

        <div style={containerInput}>

            {
                <div style={containerInputMail}>
                    <label className="textPrimaryLabelInput" style={styleLabel}>{name}</label>

                    <textarea disabled={disabled} maskChar="" mask={mask} className="textPrimaryInput" value={value} onChange={onChange} placeholder={placeholder} type={type} style={styleInput} />
                    {error != undefined

                        ?
                        <p className="textErrorInput">{error}</p>
                        :
                        <></>
                    }
                </div>
            }


        </div>


    )

}

export default Textarea